import React from 'react';
import { Link } from 'react-router-dom';

const Navbar = ({ featureScroll, contactScroll }) => {
  return (
    <div className>
      <div className="hidden md:block">
        <div className="flex justify-between p-6 items-center">
          <div className="justify-self-start">
            <img src="images/logo.jpg" alt="" />
          </div>
          <div className="flex items-center">
            <div className="mr-20 text-white navText">
              <Link to="/">Home</Link>
            </div>
            <div
              onClick={featureScroll}
              className="mr-20 text-white navText cursor-pointer"
            >
              Features
            </div>
            <div className="mr-20 text-white navText">Pricing</div>
            <div
              onClick={contactScroll}
              className="border-2 border-white rounded-full px-3 py-2 text-white navContact cursor-pointer hover:bg-blue-400 hover:border-blue-400"
            >
              Contact Us
            </div>
          </div>
        </div>
      </div>
      <div>
        <div className="md:hidden flex py-4 px-2 justify-around items-center text-sm">
          <div className="border-b pb-1 border-blue-400 hover:text-blue-400 font-semibold">
            Home
          </div>
          <div
            onClick={featureScroll}
            className="border-b pb-1 border-blue-400 font-semibold cursor-pointer"
          >
            Features
          </div>
          <div className="border-b pb-1 border-blue-400 font-semibold">
            Pricing
          </div>
          <div
            onClick={contactScroll}
            className="border border-blue-400 rounded-full px-2 py-1 font-semibold cursor-pointer"
          >
            Contact Us
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
